export default {
  EVENT_TYPE_SET_SETTINGS: 'ws:set-settings',
  SYMBOL_SETTING: Symbol('__internal__'),
};
